var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-30"},[_c('div',{staticClass:"header"},[_c('span',{staticClass:"task text-20-b"},[_vm._v("Активные задания")]),_c('span',{staticClass:"all text-16-b",on:{"click":_vm.openAllTask}},[_vm._v("Все")])]),_c('scroll-list-of-tasks',{attrs:{"listBlocks":_vm.taskList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }